'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderButtons = function (_React$Component) {
    (0, _inherits3.default)(HeaderButtons, _React$Component);

    function HeaderButtons(props, initialPhase) {
        (0, _classCallCheck3.default)(this, HeaderButtons);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HeaderButtons.__proto__ || (0, _getPrototypeOf2.default)(HeaderButtons)).call(this, props));

        _this.state = {
            phase: props.collapsedRhs ? null : initialPhase,
            isUserPrivilegedInGroup: null
        };
        _this.onAction = _this.onAction.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(HeaderButtons, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.dispatcherRef = _dispatcher2.default.register(this.onAction);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _dispatcher2.default.unregister(this.dispatcherRef);
        }
    }, {
        key: 'setPhase',
        value: function setPhase(phase, extras) {
            // TODO: delay?
            _dispatcher2.default.dispatch((0, _assign2.default)({
                action: 'view_right_panel_phase',
                phase: phase
            }, extras));
        }
    }, {
        key: 'isPhase',
        value: function isPhase(phases) {
            if (this.props.collapsedRhs) {
                return false;
            }
            if (Array.isArray(phases)) {
                return phases.includes(this.state.phase);
            } else {
                return phases === this.state.phase;
            }
        }
    }, {
        key: 'onAction',
        value: function onAction(payload) {
            if (payload.action === "view_right_panel_phase") {
                // only actions coming from header buttons should collapse the right panel
                if (this.state.phase === payload.phase && payload.fromHeader) {
                    _dispatcher2.default.dispatch({
                        action: 'hide_right_panel'
                    });
                    this.setState({
                        phase: null
                    });
                } else {
                    if (this.props.collapsedRhs && payload.fromHeader) {
                        _dispatcher2.default.dispatch({
                            action: 'show_right_panel'
                        });
                        // emit payload again as the RightPanel didn't exist up
                        // till show_right_panel, just without the fromHeader flag
                        // as that would hide the right panel again
                        _dispatcher2.default.dispatch((0, _assign2.default)({}, payload, { fromHeader: false }));
                    }
                    this.setState({
                        phase: payload.phase
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            // inline style as this will be swapped around in future commits
            return _react2.default.createElement(
                'div',
                { className: 'mx_HeaderButtons' },
                this.renderButtons()
            );
        }
    }]);
    return HeaderButtons;
}(_react2.default.Component); /*
                              Copyright 2015, 2016 OpenMarket Ltd
                              Copyright 2017 Vector Creations Ltd
                              Copyright 2017 New Vector Ltd
                              Copyright 2018 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

exports.default = HeaderButtons;


HeaderButtons.propTypes = {
    collapsedRhs: _propTypes2.default.bool
};
module.exports = exports['default'];
//# sourceMappingURL=HeaderButtons.js.map